var map = {
	"./a1.png": "8ecc",
	"./addr-empty@2x.png": "3b90",
	"./anduice-empty@2x.png": "ff92",
	"./bg-more.png": "a46a",
	"./bg-order-two.png": "9d36",
	"./bg-order.png": "0d88",
	"./o1.png": "85a9",
	"./o11.png": "dd38",
	"./o14.png": "9112c",
	"./o2.png": "e34f",
	"./o3.png": "6089",
	"./o4.png": "dcd2",
	"./o6.png": "275d",
	"./o7.png": "da38",
	"./o8.png": "36ab",
	"./o9.png": "45a5",
	"./order-all.png": "19b4",
	"./order-delivery.png": "9a5e",
	"./order-goods.png": "a1515",
	"./order-payment.png": "10ba",
	"./order-tickets.png": "8086",
	"./safari@2x.png": "faba",
	"./settings.png": "d34e",
	"./turn@2x.png": "72fa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fbbf";